export default [
  {
    text: "Registered Referrals",
    value: "registeredReferrals",
    icon:
    "<svg id=\"Layer_2\" data-name=\"Layer 2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45.45 35.08\">\n" +
      "  <defs>\n" +
      "    <style>\n" +
      "      .cls-1 {\n" +
      "        fill: #fff;\n" +
      "        stroke-width: 0px;\n" +
      "      }\n" +
      "    </style>\n" +
      "  </defs>\n" +
      "  <g id=\"V1\">\n" +
      "    <g>\n" +
      "      <g>\n" +
      "        <g>\n" +
      "          <path class=\"cls-1\" d=\"m31.65,8.99c0,.18-.01.36-.02.54l-1.74-1.74c-.54-.52-1.25-.81-2-.81s-1.47.29-2.02.84l-.76.77c-.54.53-.86,1.27-.86,2.03s.32,1.5.84,2l3.29,3.3c-1.55,1.29-3.55,2.06-5.72,2.06-4.97,0-8.99-4.02-8.99-8.99S17.69,0,22.66,0s8.99,4.03,8.99,8.99Z\"/>\n" +
      "          <path class=\"cls-1\" d=\"m32.73,35.08H12.57c-2.88,0-5.02-2.68-4.39-5.5,1.53-6.73,5.6-10.39,7.51-11.77,1.91,1.51,4.33,2.42,6.96,2.42s5.04-.91,6.96-2.42c1.9,1.38,5.98,5.04,7.5,11.77.64,2.81-1.5,5.5-4.38,5.5Z\"/>\n" +
      "        </g>\n" +
      "        <g>\n" +
      "          <path class=\"cls-1\" d=\"m14.37,17.43c-.81.3-1.67.47-2.59.47-.13,0-.26,0-.39-.02-3.83-.19-6.87-3.36-6.87-7.24s3.25-7.26,7.26-7.26c.15,0,.32,0,.47.02-.88,1.67-1.41,3.58-1.41,5.61,0,2.66.9,5.16,2.42,7.13.32.45.71.88,1.11,1.29Z\"/>\n" +
      "          <path class=\"cls-1\" d=\"m6.17,17.76c1.09.86,2.36,1.48,3.77,1.76-1.78,2.23-3.57,5.33-4.5,9.44-.21.92-.23,1.86-.09,2.76h-1.71c-2.33,0-4.05-2.18-3.55-4.45,1.24-5.44,4.54-8.41,6.08-9.51Z\"/>\n" +
      "        </g>\n" +
      "      </g>\n" +
      "      <path class=\"cls-1\" d=\"m45.2,5.61l-12.15,12.16h0l-6.54-6.55c-.33-.32-.33-.86,0-1.19l.79-.8c.33-.33.86-.32,1.2,0l4.56,4.56,10.17-10.16c.33-.33.86-.33,1.2,0l.79.79c.33.33.33.86,0,1.2Z\"/>\n" +
      "    </g>\n" +
      "  </g>\n" +
      "</svg>",
  },
  {
    text: "Deposit count",
    value: "deposit",
    icon:
    "<svg id=\"Layer_2\" data-name=\"Layer 2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 34.02 35.08\">\n" +
      "  <defs>\n" +
      "    <style>\n" +
      "      .cls-1 {\n" +
      "        fill: #fff;\n" +
      "        stroke-width: 0px;\n" +
      "      }\n" +
      "    </style>\n" +
      "  </defs>\n" +
      "  <g id=\"V1\">\n" +
      "    <g>\n" +
      "      <g>\n" +
      "        <path class=\"cls-1\" d=\"m32.8,13.52l-3.95-4.06c-1.51-1.56-3.77-1.64-6.25-.8l.05.05c.3.3.55.64.73.99,1.94-.6,3.61-.53,4.65.55,2.56,2.63-1,8.86-5.65,13.38-4.65,4.51-10.97,7.89-13.53,5.26-1.05-1.1-1.08-2.8-.39-4.75l-.96-.96c-1,2.55-1.02,4.9.53,6.5l3.94,4.06c3.32,3.4,10.22-.29,15.23-5.17,5.02-4.87,8.9-11.67,5.6-15.07Zm-6.48,14.17c-4.65,4.52-10.97,7.9-13.53,5.28l-1.91-1.97c3.6.31,8.54-2.72,12.38-6.45,3.84-3.74,7.01-8.59,6.8-12.2l1.91,1.97c2.56,2.64-.99,8.85-5.65,13.37Z\"/>\n" +
      "        <path class=\"cls-1\" d=\"m27.98,24.8c-.66.79-1.39,1.57-2.19,2.35-5.02,4.88-10.63,7.27-12.52,5.33l-.78-.81c2.58-.34,5.43-1.86,7.96-3.75.95-.71,2.13-1.09,3.37-1.02.94.05,2.33-.34,4.15-2.1Z\"/>\n" +
      "        <path class=\"cls-1\" d=\"m21.85,23.09c-5.03,4.89-10.63,7.27-12.52,5.33-.73-.75-.8-2.07-.29-3.68l1.84,1.84,11.77-11.78c1.2-1.19,1.54-2.92,1.03-4.41,1.71-.52,3.09-.44,3.85.34,1.89,1.94-.66,7.47-5.68,12.36Z\"/>\n" +
      "      </g>\n" +
      "      <path class=\"cls-1\" d=\"m21.13,13.28l-10.25,10.25L.63,13.28c-.84-.84-.84-2.21,0-3.05l1.47-1.47c.84-.84,2.21-.84,3.05,0l2.57,2.57V2.15c0-1.19.96-2.15,2.15-2.15h2c1.19,0,2.15.96,2.15,2.15v9.18l2.57-2.57c.84-.84,2.21-.84,3.05,0l1.47,1.47c.84.84.84,2.21,0,3.05Z\"/>\n" +
      "    </g>\n" +
      "  </g>\n" +
      "</svg>"
  },
  {
    text: "Reward",
    value: "rewardMMC",
    icon:
    "<svg id=\"Layer_2\" data-name=\"Layer 2\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 41.35 35.05\">\n" +
      "  <defs>\n" +
      "    <style>\n" +
      "      .cls-1 {\n" +
      "        fill: #fff;\n" +
      "        stroke-width: 0px;\n" +
      "      }\n" +
      "    </style>\n" +
      "  </defs>\n" +
      "  <g id=\"V1\">\n" +
      "    <g>\n" +
      "      <path class=\"cls-1\" d=\"m35.72,26.59s0,0,.01,0c0,0,.01-.01.02-.02-.01,0-.02,0-.03.01Z\"/>\n" +
      "      <g>\n" +
      "        <g>\n" +
      "          <path class=\"cls-1\" d=\"m22.67,0c-6.63,0-13.77,2.05-13.77,6.55v2.75c.53-.45,1.08-.83,1.63-1.13-.34-.5-.53-1.03-.53-1.63,0-3.47,6.53-5.36,12.68-5.36s12.69,1.89,12.69,5.36-6.53,5.38-12.69,5.38c-.31,0-.64,0-.95-.02.22.36.38.77.48,1.2h.47c5.08,0,10.44-1.2,12.69-3.78v2.59c0,3.49-6.53,5.36-12.69,5.36h-.38c-.05.38-.13.77-.22,1.17.2.02.39.02.59.02,6.64,0,13.77-2.05,13.77-6.55v-5.38c0-4.5-7.13-6.55-13.77-6.55Z\"/>\n" +
      "          <path class=\"cls-1\" d=\"m25.72,16.41c-.98.11-2,.16-3.05.16h-.28c.03-.27.05-.53.05-.78.7.36,1.75.63,3.28.63Z\"/>\n" +
      "          <path class=\"cls-1\" d=\"m34.71,6.55c0,2.58-5.39,4.66-12.04,4.66-.5,0-.98-.02-1.47-.05-.31-.34-.67-.64-1.11-.88l-4.74-2.52c-1.31-.7-2.77-.59-4.24.09-.31-.42-.48-.86-.48-1.31,0-2.56,5.39-4.64,12.04-4.64s12.04,2.08,12.04,4.64Z\"/>\n" +
      "        </g>\n" +
      "        <g>\n" +
      "          <path class=\"cls-1\" d=\"m36.44,10.63v1.27c2.28.89,3.83,2.22,3.83,3.91,0,3.49-6.53,5.36-12.68,5.36-2.08,0-4.2-.2-6.08-.63-.11.38-.25.75-.39,1.13,2.03.47,4.28.7,6.47.7,5.06,0,10.44-1.22,12.68-3.8v2.59c0,3.49-6.53,5.36-12.68,5.36-2.85,0-5.78-.41-8.11-1.19-.03.06-.06.13-.09.19-.16.28-.31.58-.48.86,2.5.91,5.66,1.34,8.69,1.34,6.63,0,13.76-2.06,13.76-6.57v-5.36c0-2.41-2.02-4.11-4.91-5.17Z\"/>\n" +
      "          <path class=\"cls-1\" d=\"m30.63,25.67c-.97.09-1.99.14-3.03.14-2.97,0-5.69-.41-7.78-1.11.39-.77.75-1.56,1.05-2.36.84.2,1.72.36,2.59.47,1.11.16,2.16.67,2.95,1.53.61.66,1.81,1.33,4.22,1.33Z\"/>\n" +
      "          <path class=\"cls-1\" d=\"m39.61,15.8c0,2.56-5.38,4.64-12.02,4.64-2.14,0-4.16-.22-5.88-.58.14-.47.27-.94.36-1.41.2.02.39.02.59.02,6.28,0,13.01-1.83,13.71-5.85,2.02.83,3.24,1.94,3.24,3.17Z\"/>\n" +
      "        </g>\n" +
      "        <g>\n" +
      "          <path class=\"cls-1\" d=\"m36.44,26.34v2.16c0,3.49-6.53,5.36-12.68,5.36-3.35,0-6.82-.56-9.27-1.63-.33.3-.64.58-.97.84,2.69,1.33,6.53,1.97,10.24,1.97,6.63,0,13.76-2.05,13.76-6.55v-2.61c-.34.16-.7.31-1.08.45Zm-.69.23c-1.41.45-2.97.77-4.58.95-2.2.64-4.85.97-7.41.97-1.97,0-3.99-.19-5.8-.58-.22.36-.45.7-.7,1.05,2.03.5,4.28.72,6.5.72,4.61,0,9.46-.98,11.99-3.11Z\"/>\n" +
      "          <path class=\"cls-1\" d=\"m26.8,32.98c-.97.11-1.99.16-3.03.16-3.44,0-6.55-.56-8.74-1.45.61-.63,1.2-1.33,1.77-2.08.92.23,1.88.41,2.83.53,1.11.14,2.16.67,2.95,1.53.61.66,1.81,1.31,4.22,1.31Z\"/>\n" +
      "          <path class=\"cls-1\" d=\"m26.06,27.68c-.75.06-1.52.09-2.3.09-1.94,0-3.78-.17-5.39-.5.19-.3.38-.59.53-.89,2.08.75,4.61,1.19,7.16,1.3Z\"/>\n" +
      "        </g>\n" +
      "      </g>\n" +
      "      <g>\n" +
      "        <path class=\"cls-1\" d=\"m20.09,10.29l-4.73-2.53c-2.95-1.58-6.56.95-9.51,4.75-.54.69-1.05,1.43-1.54,2.19-.17.27-.34.55-.51.82-.25.42-.5.85-.72,1.28-.87,1.62-1.62,3.36-2.16,5.06-1.41,4.43-1.42,8.64,1.45,10.17l4.73,2.53c3.97,2.12,9.15-3.2,12.28-9.05,3.13-5.85,4.68-13.11.71-15.23ZM2.89,31.09c-2.3-1.23-2.08-5.27-.61-9.5.5-1.42,1.13-2.86,1.86-4.22.32-.6.66-1.19,1.02-1.77,2.9-4.65,6.95-8.35,9.69-6.89,3.07,1.64,1.65,8.29-1.25,13.72-2.9,5.42-7.64,10.3-10.71,8.66Zm15.44-6.13c-2.9,5.42-7.63,10.3-10.71,8.66l-2.29-1.22c3.34-.76,6.93-4.92,9.33-9.4,2.39-4.48,3.86-9.78,2.63-12.97l2.29,1.22c3.07,1.64,1.65,8.29-1.25,13.72Z\"/>\n" +
      "        <path class=\"cls-1\" d=\"m18.99,21.87c-.37.9-.8,1.82-1.3,2.75-3.13,5.85-7.51,9.63-9.77,8.42l-.94-.5c2.23-1.05,4.37-3.25,6.11-5.68.65-.91,1.61-1.6,2.75-1.89.86-.22,2.01-.98,3.15-3.1Z\"/>\n" +
      "        <path class=\"cls-1\" d=\"m12.96,22.09c-3.13,5.86-7.51,9.63-9.77,8.43-1.78-.95-1.72-4.69-.1-9.1.44-1.2,1-2.45,1.67-3.71.38-.72.79-1.4,1.2-2.05,2.97-4.66,6.58-7.43,8.57-6.37,2.26,1.21,1.56,6.94-1.58,12.8Z\"/>\n" +
      "      </g>\n" +
      "    </g>\n" +
      "  </g>\n" +
      "</svg>"
  },
];
